#@import Hogan
#@export DealCarousel.CarouselTemplate

window.DealCarousel ?= {}
DealCarousel.CarouselTemplate = Hogan.compile '''
{{# renderFullCarousel }}
  <div class="gallery {{ classes }}" data-bhw="PromNightGallery" data-bhc="PromNightGallery:{{ uuid }}">
    <div class="gallery-featured">
      <div class="click-blocker"></div>
      {{# featured }}
        {{# isVideo }}
          <img src="http://cdnapi.kaltura.com/p/1302621/thumbnail/entry_id/{{ media }}/height/{{ collection.view.options.mediaHeight}}" id="gallery-video-{{ id }}" data-id="{{ id }}" />
        {{/ isVideo }}
        {{^ isVideo }}
          {{# featuredImageLowQuality }}
            <img class="featured-image sleepy-load blurred init-no-animation" src="{{ featuredImageLowQuality }}" id="gallery-image-{{ id }}" data-original="{{ media }}" data-id="{{ id }}" {{# alt }}alt="{{ alt }}"{{/ alt }} />
          {{/ featuredImageLowQuality }}
          {{^ featuredImageLowQuality }}
            {{# lazyLoadFeatured }}<img class="featured-image sleepy-load blurred init-no-animation" src="{{ featuredImageThumbnail }}" id="gallery-image-{{ id }}" data-original="{{ media }}" data-id="{{ id }}" {{# alt }}alt="{{ alt }}"{{/ alt }} />{{/ lazyLoadFeatured }}
            {{^ lazyLoadFeatured }}<img class="init-no-animation" src="{{ media }}" id="gallery-image-{{ id }}" data-id="{{ id }}" {{# alt }}alt="{{ alt }}"{{/ alt }} />{{/ lazyLoadFeatured }}
          {{/ featuredImageLowQuality }}
        {{/ isVideo }}
      {{/ featured }}
    </div>

    {{# showThumbs }}
      <ul class="gallery-thumbs">
        {{# models }}
          <li class="gallery-thumbnail{{# isFeatured }} selected{{/ isFeatured }}{{# isVideo }} video{{/ isVideo }}{{^ thumb }} no-thumbnail{{/ thumb }}{{# isLast }} last{{/ isLast }}" id="gallery-thumb-{{ id }}" data-id="{{ id }}" data-bhc="thumbnail_click:{{ id }}"{{# isVideo }} data-bhd="{{ videoBHD }}"{{/ isVideo }}>
            {{# thumb }}
              {{# lazyLoadThumbs }}<img class="lazy-load" data-original="{{ thumb }}" />{{/ lazyLoadThumbs }}
              {{^ lazyLoadThumbs }}<img src="{{ thumb }}" />{{/ lazyLoadThumbs }}
            {{/ thumb }}
          </li>
        {{/ models }}
      </ul>
    {{/ showThumbs }}

    <div class="gallery-controls">
      {{# showProductSizing }}
        <div class="tangiblee-btn-groupon" data-bhw="TangibleeButton">
          <div class="compare-size-background"></div>
          <div class="compare-size-icon"></div>
          <div class="compare-size-text">{{ compareSizeMessage }}</div>
        </div>
      {{/ showProductSizing }}

      {{# showRTL }}
        {{# showThumbs }}
          <div class="gallery-control-back icon-arrow-right-large disabled" data-bhc="thumbnail_back:{{ uuid }}"></div>
          <div class="gallery-control-forward icon-arrow-left-large" data-bhc="thumbnail_forward:{{ uuid }}"></div>
        {{/ showThumbs }}

        <div class="gallery-control-left icon-arrow-right-large disabled" data-bhc="bumper_left:{{ uuid }}"></div>
        <div class="gallery-control-right icon-arrow-left-large" data-bhc="bumper_right:{{ uuid }}"></div>
      {{/ showRTL }}

      {{^ showRTL }}
        {{# showThumbs }}
          <div class="gallery-control-back icon-arrow-left-large disabled" data-bhc="thumbnail_back:{{ uuid }}"></div>
          <div class="gallery-control-forward icon-arrow-right-large" data-bhc="thumbnail_forward:{{ uuid }}"></div>
        {{/ showThumbs }}

        <div class="gallery-control-left icon-arrow-left-large disabled" data-bhc="bumper_left:{{ uuid }}"></div>
        <div class="gallery-control-right icon-arrow-right-large" data-bhc="bumper_right:{{ uuid }}"></div>
      {{/ showRTL }}
    </div>
  </div>
{{/ renderFullCarousel }}
{{^ renderFullCarousel }}
  <div class="gallery-single">
    <div class="gallery-featured">
      {{# first }}

        {{# featuredImageLowQuality }}
          <img class="featured-image sleepy-load blurred init-no-animation" src="{{ featuredImageLowQuality }}" data-original="{{ media }}" data-id="{{ id }}" {{# alt }}alt="{{ alt }}"{{/ alt }} />
        {{/ featuredImageLowQuality }}
        {{^ featuredImageLowQuality }}
          {{# lazyLoadFeatured }}<img class="featured-image sleepy-load blurred init-no-animation" src="{{ featuredImageThumbnail }}" data-original="{{ media }}" data-id="{{ id }}" {{# alt }}alt="{{ alt }}"{{/ alt }} />{{/ lazyLoadFeatured }}
          {{^ lazyLoadFeatured }}<img class="featured-image init-no-animation" src="{{ media }}" data-id="{{ id }}" {{# alt }}alt="{{ alt }}"{{/ alt }} />{{/ lazyLoadFeatured }}
        {{/ featuredImageLowQuality }}

      {{/ first }}
    </div>
    <div class="gallery-controls">
      {{# showProductSizing }}
        <div class="tangiblee-btn-groupon" data-bhw="TangibleeButton">
          <div class="compare-size-background"></div>
          <div class="compare-size-icon"></div>
          <div class="compare-size-text">{{ compareSizeMessage }}</div>
        </div>
      {{/ showProductSizing }}
    </div>
  </div>
{{/ renderFullCarousel }}
'''
